export default "__VITE_ASSET__764tny61__"